import { Controller } from "@hotwired/stimulus";

const HubContactMessageController = class extends Controller {
  open(event) {
    const contactId = event.params.contactId;
    const contactName = event.params.contactName;
    this.contactIdTarget.value = contactId;
    this.recipientNameTarget.textContent = contactName;
    this.modalTarget.hidden = false;
    this.bodyTarget.focus();
  }

  close() {
    this.modalTarget.hidden = true;
    this.bodyTarget.value = "";
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) {
      this.close();
    }
  }

  closeOnEscape() {
    if (!this.modalTarget.hidden) {
      this.close();
    }
  }
};

HubContactMessageController.targets = [
  "modal",
  "contactId",
  "recipientName",
  "body",
];

export default HubContactMessageController;
